import {IJobsAction} from './actions';
import {
  SEND_USER_MAIL_PENDING,
  SEND_USER_MAIL_REJECTED,
  SEND_USER_MAIL_FULFILLED,
} from './constants';

export interface IJobsFormData {
  jobUsername: string;
  jobEmail: string;
  jobDescription: string;
}

export interface IJobsState {
  isLoading: boolean;
  formData?: IJobsFormData;
  submittedForms: Array<string>;
}

const initialState: IJobsState = {
  isLoading: false,
  submittedForms: [],
  formData: {
    jobUsername: '',
    jobEmail: '',
    jobDescription: '',
  },
};

export default function jobsReducer(
  state: IJobsState = initialState,
  action: IJobsAction,
): IJobsState {
  const {type, payload} = action;
  switch (type) {
    case SEND_USER_MAIL_FULFILLED:
      const {jobKey} = payload;
      const {submittedForms} = state;
      return {
        ...state,
        isLoading: false,
        submittedForms: [...submittedForms, jobKey],
      };
    case SEND_USER_MAIL_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case SEND_USER_MAIL_REJECTED:
      return {
        ...state,
        isLoading: false,
      };
    default: return state;
  }
}
